import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { fc } from 'i18n';
import { IMultipleEditForm } from 'types/tep';
import Input from 'core/react/general/form/Input';

import styles from './styles.module.css';

interface IEmailProps {
  rowIndex: number;
}

export const Email: FC<IEmailProps> = ({ rowIndex }) => {
  const { formState, control } = useFormContext<IMultipleEditForm>();

  const { errors } = formState;

  const error = errors.leases?.[rowIndex]?.email?.message;

  return (
    <Controller
      control={control}
      name={`leases.${rowIndex}.email`}
      rules={{ required: fc('please enter email') }}
      render={({ value, onChange }) => (
        <div className={styles.input}>
          <Input placeholder="enter email address" value={value} onChange={onChange} />
          {/*TODO: error messages should be moved to corresponding form components when they are being refactored*/}
          {!!error && <div className={styles.error}>{error}</div>}
        </div>
      )}
    />
  );
};
